import { Delete } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import useStore from "./useStore";
import { txt } from "../../../services/translation"

export default function ItemBin(){

    const { selectedItem, removeItem, deselectItem } = useStore()

    const handleClick = () => {
        removeItem(selectedItem.id)
        deselectItem()
    }

    return selectedItem &&
        <Tooltip title={txt('deleteSelection')} onClick={handleClick}>
            <IconButton>
                <Delete />
            </IconButton>
        </Tooltip>
}